import React, { useState, useEffect, useRef, useContext } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../Images/logo.svg";
import { Navbar, Nav as BsNav, Container, Row, Col } from "react-bootstrap";
import helpIcon from "../Images/aivideo1.gif";
import { Link } from "react-router-dom";
import "./Navbar.css";
import { MdKeyboardArrowDown } from "react-icons/md";
import { IoArrowRedoSharp } from "react-icons/io5";
import { GlobalContext } from "../Context/GlobalState";
import { BASE_URL_API_TRANXT_UAT_API } from "../Utils/Constant";
const Nav = () => {
  const { userData, setUserData } = useContext(GlobalContext);
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const [activeChildSubmenu, setActiveChildSubmenu] = useState(null);
  const submenuRef = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [randomNumber, setRandomNumber] = useState(null);
  const [hoverDropdown, setHoverDropdown] = useState(null);
  const [openedByClick, setOpenedByClick] = useState(false);
  useEffect(() => {
    const storedUser = localStorage.getItem("googleUser");
    if (storedUser) {
      setUserData(JSON.parse(storedUser));
    }
  }, []);

  useEffect(() => {
    let existingId = sessionStorage.getItem("randomState");

    if (!existingId) {
      existingId = Math.floor(Math.random() * 1000000).toString();
      sessionStorage.setItem("randomState", existingId);
      localStorage.setItem("googleSignupId", existingId); // optional persistence
      console.log("🆕 Generated randomState on Landing Page:", existingId);
    } else {
      console.log("🔁 Using existing randomState on Landing Page:", existingId);
    }

    setRandomNumber(existingId);
  }, []);
  useEffect(() => {
    if (!randomNumber) return;

    const storedUser = localStorage.getItem("googleUser");

    if (storedUser) {
      setUserData(JSON.parse(storedUser));
      console.log("🔁 Loaded user from localStorage:", JSON.parse(storedUser));
      return;
    }

    const getGoogleCredentials = async () => {
      try {
        const res = await fetch(
          `${BASE_URL_API_TRANXT_UAT_API}/api/GoogleAuth/GetGoogleCredentials`,
         {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: randomNumber }),
          }
        );

        const data = await res.json();
        console.log("✅ Landing Page API Response:", data);

        if (data.status === "0" && data.data?.[0]?.token_login) {
          setUserData(data.data[0]);
          localStorage.setItem("googleUser", JSON.stringify(data.data[0]));
        } else {
          setUserData(null);
        }
      } catch (err) {
        console.error("❌ Error fetching credentials:", err);
      }
    };

    getGoogleCredentials();
  }, [randomNumber]);

  const goToDashboard = async () => {
    const existingId =
      sessionStorage.getItem("randomState") ||
      localStorage.getItem("googleSignupId");
// console.log(existingId);
    if (!existingId) {
      console.warn("⚠️ No randomState found, cannot proceed to dashboard.");

      return;
    }else{
    window.location.href = `https://dashboard.seobix.com/?state=${existingId}`;

    // Fetch credentials before opening dashboard
    }
  };

  const handleMenuEnter = () => {
    if (window.innerWidth >= 992) {
      clearTimeout(hoverTimeoutRef.current);
      setHoverDropdown("tools");
    }
  };

  const handleMenuLeave = () => {
    if (window.innerWidth >= 992 && !openedByClick) {
      hoverTimeoutRef.current = setTimeout(() => {
        setHoverDropdown(null);
      }, 300);
    }
  };
  const hoverTimeoutRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (submenuRef.current && !submenuRef.current.contains(event.target)) {
        setHoverDropdown(null);
        setOpenedByClick(false);
        setActiveSubmenu(null);
        setActiveChildSubmenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        // lg breakpoint
        setExpanded(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const submenuData = [
    {
      name: "Competitive Research",
      subMenu: [
        {
          name: "Domain Authority",
          desc: "Check DA and PA and track your domain age for Free",
          href: "/da-pa-checker",
        },

        {
          name: "SERP Simulator",
          desc: "Craft and test meta descriptions visually, instantly",
          href: "/serp-simulator",
        },
        {
          name: "Keyword Gap",
          desc: "Find Competitor’s  Ranking keywords and grow your traffic",
          href: "/keyword-gap",
        },
        {
          name: "Top Pages",
          desc: "Find the top domains linked to your website",
          href: "/top-pages",
        },
      ],
    },
    {
      name: "Page Seo",
      subMenu: [
        {
          name: "SEO Inspector",
          desc: "Audit Your Website Errors in Seconds",
          href: "/seo-Inspector",
        },
        {
          name: "On Pages Seo",
          desc: "One click to optimize your entire site’s SEO",
          href: "/on-page-seo-tool",
        },
        {
          name: "Structure Data",
          desc: "Turn content into rich snippets with structured data",
          href: "/structured-data",
        },
        {
          name: "Robots.txt",
          desc: "Generate a perfect Crawler control file quickly.",
          href: "/manage-robots-txt",
        },
      ],
    },
    {
      name: "Content Checker",
      subMenu: [
        {
          name: "Bix Content Generator",
          desc: "Generate Quality Content with SeoBix’s Bix Content Generator",
          href: "/bix-content-generator",
        },
        {
          name: "Quality Content Checker",
          desc: "Analyze the AI content & quality of the content ",
          href: "/content-quality-checker",
        },
        {
          name: "Humanizer",
          desc: "Humanize AI-generated content with Humanizer",
          href: "/bix-humanizer",
        },
        {
          name: "Guest Post",
          desc: "See top disciplines linking to your point for guest advertisement leads.",
          href: "/guest-post",
        },
      ],
    },
    {
      name: "Backlinks",
      subMenu: [
        {
          name: "Backlink Checker",
          desc: "Analyze the backlinks of your domains",
          href: "/backlink-checker",
        },
        {
          name: "Link Building Tool",
          desc: "Store Your Backlinks easily with SeoBix",
          href: "/link-building-tool",
        },
        {
          name: "Linking Domain",
          desc: "Measure a site's authority by the number, quality, and variety of unique websites linking to it.",
          href: "/linking-domain-checker",
        },
      ],
    },
    {
      name: "Keyword Research",
      subMenu: [
        {
          name: "Bix keyword Research",
          desc: "Find the best keywords for SEO success",
          href: "/best-keyword-research-tool",
        },
        {
          name: "Domain Ranking Keyword",
          desc: "Track keywords of your domain",
          href: "/bix-keyword-analyzer",
        },
        {
          name: "Keyword Builder",
          desc: "Store smart keyword ideas in seconds",
          href: "/construct-your-seo-success-with-keyword-builder",
        },
      ],
    },

    {
      name: "Bix Lab With Google",
      subMenu: [
        {
          name: "Google Analytics",
          desc: "Integrated Google Analytics by connecting your domain.",
          href: "/google-analytics",
        },
        {
          name: "Google Search Console",
          desc: "Analyze your domain traffic by linking your domain. ",
          href: "/search-console",
        },
        {
          name: "Google Trends",
          desc: "Go with the trends and boost your traffic with SeoBix",
          href: "/trending-now-on-google",
        },
      ],
    },
  ];
  const socialToolsMenuData = [
    {
      name: "YouTube ",
      subMenu: [
        {
          name: "Scheduled and Publishing",
          desc: "Schedule videos to publish automatically.",
          href: "/youtube-scheduled-publishing",
        },
        {
          name: "Subscription Tracker",
          desc: "Monitor your channel subscribers and growth trends.",
          href: "/youtube-subscription-tracker",
        },
        {
          name: "Trending Tags and Search",
          desc: "Find popular and high-performing tags.",
          href: "/youtube-trending-tags-finder",
        },
        {
          name: "Bix Intelligence",
          desc: "Get AI-driven recommendations for content optimization.",
          href: "/youtube-bix-intelligence",
        },
        {
          name: "Content Planner",
          desc: "Plan and organize your video content ideas.",
          href: "/youtube-content-planner",
        },
        {
          name: "Insight Analyzer",
          desc: "Track video performance, audience stats, and engagement.",
          href: "/youtube-insight-analyzer",
        },
      ],
    },
    {
      name: "Facebook ",
      subMenu: [
        {
          name: "Profile & Page Analyzer",
          desc: "Evaluate page performance, engagement, and reach.",
          href: "/facebook-profile-page-analyzer",
        },
        {
          name: "Post & Content Creator",
          desc: "Create posts, images, and videos optimized for Facebook.",
          href: "/facebook-post-content-creator",
        },
        {
          name: "Post Scheduler",
          desc: "Schedule posts for peak engagement times.",
          href: "/facebook-post-scheduler",
        },
        {
          name: "Hashtag Finder",
          desc: "Discover trending and niche-specific hashtags.",
          href: "/facebook-hashtag-finder",
        },
      ],
    },
    {
      name: "LinkedIn ",
      subMenu: [
        {
          name: "Profile Analyzer",
          desc: "Assess profile strength and optimization opportunities.",
          href: "/linkedin-profile-analyzer",
        },
        {
          name: "Post & Article Creator",
          desc: "Create professional posts and long-form articles.",
          href: "/linkedin-post-article-creator",
        },
        {
          name: "Post Scheduler",
          desc: "Schedule updates, posts, and articles efficiently.",
          href: "/linkedin-post-scheduler",
        },
        {
          name: "Hashtag Research Tool",
          desc: "Find relevant and trending LinkedIn hashtags.",
          href: "/linkedin-hashtag-research-tool",
        },
      ],
    },
    {
      name: "Instagram ",
      subMenu: [
        {
          name: "Profile Analyzer",
          desc: "Evaluate your profile performance and growth potential.",
          href: "/instagram-profile-analyzer",
        },
        {
          name: "Post & Reel Creator",
          desc: "Create high-quality posts and reels with ease.",
          href: "/instagram-post-reel-creator",
        },
        {
          name: "Post Scheduler",
          desc: "Schedule your posts and reels for optimal engagement.",
          href: "/instagram-post-scheduler",
        },
        {
          name: "Hashtag Generator",
          desc: "Discover trending and niche-specific hashtags.",
          href: "/instagram-hashtag-generator",
        },
        {
          name: "Tag Analyzer",
          desc: "Analyze hashtags and tags for maximum reach.",
          href: "/instagram-tag-analyzer",
        },
      ],
    },
  ];

  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    console.log("🧩 userData changed:", userData);
  }, [userData]);

  return (
    <>
      <div
        className="d-flex justify-content-center"
        style={{
          background:
            "linear-gradient(to right, #AFDDFF 0%, #C5E7FF 30%, #DAF0FF 60%, #EDF8FF 85%, #FFFFFF 100%)",
        }}
      >
        <div
          className="d-flex flex-column flex-md-row align-items-center justify-content-center text-center text-md-start p-2 m-0"
          style={{
            fontFamily: "'Poppins', sans-serif",
            fontSize: ".9rem",
            fontWeight: "600",
            color: "#003366",
            letterSpacing: "0.5px",
            lineHeight: "1.6",
          }}
        >
          <img
            src={helpIcon}
            alt="Help"
            style={{
              width: "2rem",
              height: "2rem",
              marginRight: "0.5rem",
              marginBottom: "0.5rem",
            }}
          />
          <span>
            Analyze your website’s SEO health effortlessly with
            <strong> SeoBix’s Free SEO Tools</strong>.
            <a
              href="/seo-Inspector"
              className="text-decoration-none"
              style={{ marginLeft: "0.5rem", color: "inherit" }}
            >
              <span style={{ color: "#FC4100" }}>
                Start Inspection <IoArrowRedoSharp />
              </span>
            </a>
          </span>
        </div>
      </div>
      <div
        className={`sticky-navbar-wrapper ${isScrolled ? "shadow-sm" : ""}`}
        style={{
          position: "sticky",
          top: 0,
          zIndex: 1050,
          background: "white",
        }}
      >
        <Row className="d-flex justify-content-center mx-md-0 mx-2">
          <Col md={10}>
            <Navbar expand="lg" bg="white" expanded={expanded}>
              <Navbar.Brand as={Link} to="/" style={{ marginRight: "6rem" }}>
                <img src={logo} alt="Logo" style={{ height: "3rem" }} />
              </Navbar.Brand>

              <Navbar.Toggle
                aria-controls="responsive-navbar-nav"
                onClick={() => setExpanded(!expanded)}
              />

              <Navbar.Collapse
                id="responsive-navbar-nav"
                style={{ overflowX: "hidden" }}
              >
                <BsNav className="me-auto d-flex align-items-lg-center gap-5">
                  <div
                    className="dropdown-wrapper"
                    ref={submenuRef}
                    onMouseEnter={handleMenuEnter}
                    onMouseLeave={handleMenuLeave}
                  >
                    <li className="nav-item dropdown position-static">
                      <a
                        className="nav-link m-0"
                        href="#"
                        id="toolsDropdown"
                        role="button"
                        aria-expanded={hoverDropdown === "tools"}
                        onMouseEnter={() => {
                          if (window.innerWidth >= 992 && !openedByClick) {
                            setHoverDropdown("tools");
                          }
                        }}
                        onMouseLeave={() => {
                          if (window.innerWidth >= 992 && !openedByClick) {
                            setHoverDropdown(null);
                          }
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          const isOpen = hoverDropdown === "tools";
                          const isMobile = window.innerWidth < 992;

                          if (isOpen && openedByClick) {
                            setHoverDropdown(null);
                            setOpenedByClick(false);
                          } else {
                            setHoverDropdown("tools");
                            setOpenedByClick(true);
                          }

                          if (isMobile) {
                            setActiveSubmenu(null);
                            setActiveChildSubmenu(null);
                          }
                        }}
                      >
                        <span
                          className={`d-flex align-items-center gap-1 nav-link-underline ${
                            hoverDropdown === "tools" ? "active" : ""
                          }`}
                        >
                          SEO <MdKeyboardArrowDown size={18} />
                        </span>
                      </a>

                      <div
                        className={`dropdown-menu mt-0 border-0 ${
                          hoverDropdown === "tools" && window.innerWidth >= 992
                            ? "show"
                            : ""
                        }`}
                        aria-labelledby="toolsDropdown"
                        onMouseEnter={handleMenuEnter}
                        onMouseLeave={handleMenuLeave}
                        style={{
                          borderTopLeftRadius: 0,
                          borderTopRightRadius: 0,
                          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                          left: 0,
                          right: 0,
                        }}
                      >
                        <Container>
                          <div className="row mt-3">
                            {submenuData.map((section, index) => (
                              <div
                                key={index}
                                className="col-md-6 col-lg-2 mb-3"
                              >
                                <div className="list-group ">
                                  <p className="mb-1 list-group-item text-uppercase fw-bold text-decoration-underline bg-white border-0">
                                    {section.name}
                                  </p>
                                  {section.subMenu.map((item, subIndex) => (
                                    <a
                                      key={subIndex}
                                      href={item.href}
                                      className="list-group-item list-group-item-action"
                                    >
                                      <i className="fas fa-caret-right "></i>
                                      <strong style={{ fontSize: ".9rem" }}>
                                        {item.name}
                                      </strong>
                                      {item.desc && (
                                        <p
                                          style={{
                                            fontSize: "small",
                                            marginBottom: 0,
                                          }}
                                        >
                                          {item.desc}
                                        </p>
                                      )}
                                    </a>
                                  ))}
                                </div>
                              </div>
                            ))}
                          </div>
                        </Container>
                      </div>
                    </li>
                  </div>
                  <div
                    className="dropdown-wrapper"
                    ref={submenuRef}
                    onMouseEnter={handleMenuEnter}
                    onMouseLeave={handleMenuLeave}
                  >
                    <li className="nav-item dropdown position-static">
                      <a
                        className="nav-link m-0"
                        href="#"
                        id="socialDropdown"
                        role="button"
                        aria-expanded={hoverDropdown === "social"}
                        onMouseEnter={() => {
                          if (window.innerWidth >= 992 && !openedByClick) {
                            setHoverDropdown("social");
                          }
                        }}
                        onMouseLeave={() => {
                          if (window.innerWidth >= 992 && !openedByClick) {
                            setHoverDropdown(null);
                          }
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          const isOpen = hoverDropdown === "social";
                          const isMobile = window.innerWidth < 992;

                          if (isOpen && openedByClick) {
                            setHoverDropdown(null);
                            setOpenedByClick(false);
                          } else {
                            setHoverDropdown("social");
                            setOpenedByClick(true);
                          }

                          if (isMobile) {
                            setActiveSubmenu(null);
                            setActiveChildSubmenu(null);
                          }
                        }}
                      >
                        <span
                          className={`d-flex align-items-center gap-1 nav-link-underline ${
                            hoverDropdown === "social" ? "active" : ""
                          }`}
                        >
                          SMO <MdKeyboardArrowDown size={18} />
                        </span>
                      </a>

                      <div
                        className={`dropdown-menu mt-0 border-0 ${
                          hoverDropdown === "social" && window.innerWidth >= 992
                            ? "show"
                            : ""
                        }`}
                        aria-labelledby="socialDropdown"
                        onMouseEnter={handleMenuEnter}
                        onMouseLeave={handleMenuLeave}
                        style={{
                          borderTopLeftRadius: 0,
                          borderTopRightRadius: 0,
                          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                          left: 0,
                          right: 0,
                        }}
                      >
                        <Container>
                          <div className="row mt-3">
                            {socialToolsMenuData.map((section, index) => (
                              <div
                                key={index}
                                className="col-md-6 col-lg-3 mb-3"
                              >
                                <div className="list-group">
                                  <p className="mb-1 list-group-item text-uppercase fw-bold text-decoration-underline bg-white border-0">
                                    {section.name}
                                  </p>
                                  {section.subMenu.map((item, subIndex) => (
                                    <a
                                      key={subIndex}
                                      href={item.href}
                                      className="list-group-item list-group-item-action"
                                    >
                                      <strong style={{ fontSize: ".9rem" }}>
                                        {item.name}
                                      </strong>
                                      {item.desc && (
                                        <p
                                          style={{
                                            fontSize: "small",
                                            marginBottom: 0,
                                          }}
                                        >
                                          {item.desc}
                                        </p>
                                      )}
                                    </a>
                                  ))}
                                </div>
                              </div>
                            ))}
                          </div>
                        </Container>
                      </div>
                    </li>
                  </div>

                  <a href="/partners" className="nav-link-underline">
                    Partners
                  </a>
                  <a href="/blog" className="nav-link-underline">
                    Blogs
                  </a>
                  <a href="/pricing-plans" className="nav-link-underline">
                    Pricing
                  </a>
                </BsNav>
                {userData ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      background: "#f8f9fa",
                      padding: "6px 12px",
                      borderRadius: "8px",
                      border: "1px solid #ddd",
                    }}
                  >
                    <img
                      src={userData.profile_url}
                      alt={userData.display_name}
                      style={{
                        width: "35px",
                        height: "35px",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                    <span style={{ fontWeight: 500, color: "#333" }}>
                      {userData.display_name}
                    </span>
                    <button
                      onClick={goToDashboard}
                      style={{
                        backgroundColor: "#007bff",
                        color: "#fff",
                        border: "none",
                        borderRadius: "6px",
                        padding: "6px 12px",
                        fontWeight: 500,
                        cursor: "pointer",
                      }}
                    >
                      Go to Dashboard
                    </button>
                  </div>
                ) : (
                  <>
                    <div className="d-flex flex-column flex-lg-row align-items-start align-items-lg-center gap-2 mt-3 mt-lg-0">
                      <span
                        style={{
                          color: "#333",
                          fontWeight: 500,
                          cursor: "pointer",
                          padding: "4px 12px",
                          border: "2px solid #007bff",
                          borderRadius: "6px",
                          fontSize: ".9rem",
                          whiteSpace: "nowrap",
                        }}
                        onClick={() => {
                          const dashboardUrl = "https://dashboard.seobix.com/";
                          window.open(dashboardUrl, "_blank");
                        }}
                      >
                        Login
                      </span>

                      <span
                        style={{
                          color: "#333",
                          fontWeight: 500,
                          cursor: "pointer",
                          padding: "4px 12px",
                          border: "2px solid #007bff",
                          borderRadius: "6px",
                          fontSize: ".9rem",
                          whiteSpace: "nowrap",
                        }}
                        onClick={() =>
                          window.open("https://dashboard.seobix.com/", "_blank")
                        }
                      >
                        Book a Demo
                      </span>

                      <a
                        onClick={() =>
                          window.open("https://dashboard.seobix.com/", "_blank")
                        }
                      >
                        <span
                          style={{
                            color: "#fff",
                            fontWeight: 500,
                            cursor: "pointer",
                            padding: "7px 12px",
                            border: "1px solid #007bff",
                            backgroundColor: "#007bff",
                            borderRadius: "6px",
                            fontSize: ".9rem",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Get Started Free
                        </span>
                      </a>
                    </div>
                  </>
                )}
              </Navbar.Collapse>
            </Navbar>
          </Col>
        </Row>
      </div>{" "}
    </>
  );
};

export default Nav;
